import { Link } from "react-router-dom";
import styles from "./ListRecord.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { ChevronDown, ChevronUp, Code, HelpCircle } from "react-feather";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";

const BootstrapTooltip = styled(({ className, ...props }) => (<Tooltip {...props} arrow classes={{ popper: className }} />))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    fontSize: 13,
  },
}));

const ListRecords = ({ filterredData, perPage, page, filterData }) => {
  const [sortItem, setSortItem] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const changeSortOrder = (type) => {
    if (type === sortItem) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
      } else {
        setSortOrder("asc");
      }
    } else {
      setSortOrder("asc");
    }
    setSortItem(type);
  };
  return (<>
    <div className={`${styles.IncomeListUnderSec}`}>
      <div className={`${styles.ListCardDivSec}`}>
        {filterredData.map((item, index) => {
          return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<Link to={"/income/all-income/details/" + item?.rent_roll_id}>
            <div className={`${styles.CardDivList}`} key={index}>
              <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                <img src={item?.tenant_image} alt="" />
                <div>
                  <p className={`${styles.Name}`}>{item?.tenant_name}</p>
                  <p className={`${styles.Name}`}>{item?.property_name} - {item?.apt_no}</p>
                </div>
              </div>
              <div className={`${styles.SecondSec}`}>
                <p className={`${styles.Name}`}>Payment: <span>${item?.payment_status === 2 ? item?.formatted_failed_amount : item?.formatted_amount}</span></p>
                <p className={`${styles.Name}`}>
                  Date:{" "}
                  <span>{item?.date ? dayjs(item?.date).format("MM/DD/YYYY") : " - "}</span>
                </p>
              </div>
              <div className={`${styles.ThirdSec}`}>
                {item?.payment_status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Pending</span>)}
                {item?.payment_status === 1 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Completed</span>)}
                {item?.payment_status === 2 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Failed</span>)}
              </div>
              <div className={`${styles.ForthSec}`}>
                <div className={`${styles.CategoryNameSecSmall}`}>
                  {item?.categories.map((c, i) => {
                    return (<span className={`${styles.CategoryBadge}`} style={{ backgroundColor: c?.color }}>{c?.title}</span>);
                  })}
                </div>
              </div>
            </div>
          </Link>) : null;
        })}
      </div>
      <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={`${styles.TableHead}`} style={{ width: 280 }} onClick={(e) => changeSortOrder("tenant_name")}>
                Name
                {sortItem === "tenant_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "tenant_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "tenant_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("formatted_amount")}>
                PAYMENT
                {sortItem === "formatted_amount" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "formatted_amount" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "formatted_amount" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("date")}>
                DATE
                {sortItem === "date" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "date" && sortOrder === "desc" && <ChevronUp />}
                {sortItem !== "date" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 280 }}>Categories</TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("property_name")}>
                PROPERTY
                {sortItem === "property_name" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "property_name" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "property_name" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("apt_no")}>
                APT NO
                {sortItem === "apt_no" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "apt_no" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "apt_no" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
              <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={(e) => changeSortOrder("payment_status")}>
                STATUS
                {sortItem === "payment_status" && sortOrder === "asc" && (<ChevronDown />)}
                {sortItem === "payment_status" && sortOrder === "desc" && (<ChevronUp />)}
                {sortItem !== "payment_status" && (<Code className={`${styles.Normal}`} />)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterredData?.length > 0 && filterredData?.sort((a, b) => {
              if (sortItem === "tenant_name") {
                if (sortOrder === "desc") {
                  return a.tenant_name < b.tenant_name ? 1 : -1;
                } else {
                  return a.tenant_name > b.tenant_name ? 1 : -1;
                }
              } else if (sortItem === "formatted_amount") {
                if (sortOrder === "desc") {
                  return a.formatted_amount < b.formatted_amount ? 1 : -1;
                } else {
                  return a.formatted_amount > b.formatted_amount ? 1 : -1;
                }
              } else if (sortItem === "date") {
                if (sortOrder === "desc") {
                  return a.date < b.date ? 1 : -1;
                } else {
                  return a.date > b.date ? 1 : -1;
                }
              } else if (sortItem === "property_name") {
                if (sortOrder === "desc") {
                  return a.property_name < b.property_name ? 1 : -1;
                } else {
                  return a.property_name > b.property_name ? 1 : -1;
                }
              } else if (sortItem === "apt_no") {
                if (sortOrder === "desc") {
                  return a.apt_no < b.apt_no ? 1 : -1;
                } else {
                  return a.apt_no > b.apt_no ? 1 : -1;
                }
              } else if (sortItem === "payment_status") {
                if (sortOrder === "desc") {
                  return a.payment_status < b.payment_status ? 1 : -1;
                } else {
                  return a.payment_status > b.payment_status ? 1 : -1;
                }
              } else {
                return a.date > b.date ? -1 : 1;
              }
            })?.map((item, index) => {
              return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? (<Link to={"/income/all-income/details/" + item?.rent_roll_id} className={`${styles.TableLink}`}>
                <TableRow key={index}>
                  <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.NameSec}`}>
                    <img src={item?.tenant_image} alt="" />
                    {item?.tenant_name}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>
                    {filterData.category && filterData.category !== "all" ? (<div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      ${item.categories?.find((c) => c.id === filterData.category)?.amount ?? "0.00"}
                      <BootstrapTooltip title={`Total: $${item.formatted_amount}`}>
                        <HelpCircle size={15} />
                      </BootstrapTooltip>
                    </div>) : (<BootstrapTooltip title={item?.categories?.length > 0 ? (<div className={`${styles.TooltipListRow}`}>
                      {item.categories.map((ct, i) => (<div key={i} className={`${styles.TooltipList}`}>{ct?.title}: ${ct?.amount}</div>))}
                    </div>) : ("No category")}>
                      ${item?.payment_status === 2 ? item?.formatted_failed_amount : item?.formatted_amount}
                    </BootstrapTooltip>)}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.date ? dayjs(item?.date).format("MM/DD/YYYY") : " - "}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>
                    {(filterData.category && filterData.category !== "all" ? item.categories?.filter((c) => c.id === filterData.category) : item.categories).map((c, i) => (<span key={i} className={`${styles.CategoryBadge}`} style={{ backgroundColor: c?.color }}>{c?.title}</span>))}
                  </TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.property_name}</TableCell>
                  <TableCell className={`${styles.TableBodyText}`}>{item?.apt_no}</TableCell>
                  <TableCell>
                    {item?.payment_status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Pending</span>)}
                    {item?.payment_status === 1 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Completed</span>)}
                    {item?.payment_status === 2 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Failed</span>)}
                  </TableCell>
                </TableRow>
              </Link>) : null;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
    <div className={`${styles.ListMobileView}`}>
      {filterredData.map((item, index) => {
        return (
          <Link to={"/income/all-income/details/" + item?.rent_roll_id} className={`${styles.MaintenanceReqCard}`}>
            <div className={`${styles.CardImgSec} Secondary`}>
              <img src={item?.tenant_image} alt="" />
            </div>
            <div className={`${styles.MainReCardCon}`}>
              <div>
                <div className={`${styles.MainReCardIdStatus}`}>
                  <p className={`${styles.Title}`}>{item?.tenant_name}</p>
                  {item?.payment_status === 0 && (<span className={`${styles.StatusBadge} ${styles.Pending}`}>Pending</span>)}
                  {item?.payment_status === 1 && (<span className={`${styles.StatusBadge} ${styles.Confirm}`}>Completed</span>)}
                  {item?.payment_status === 2 && (<span className={`${styles.StatusBadge} ${styles.Failed}`}>Failed</span>)}
                </div>
                <div className={`${styles.MainReCardIdStatus}`}>
                  <p className={`${styles.MainReID}`}>
                    <span>${item?.payment_status === 2 ? item?.formatted_failed_amount : item?.formatted_amount}</span>
                    <span>{item?.date ? dayjs(item?.date).format("MM/DD/YYYY") : " - "}</span>
                  </p>
                </div>
                <div className={`${styles.MainReCardIdStatus}`}>
                  <p className={`${styles.MainReID}`}>
                    {item?.categories.map((c, i) => {
                      return (<span>{c?.title}</span>);
                    })}
                  </p>
                </div>
                <div className={`${styles.MainReCardIdStatusTwo}`}>
                  <p className={`${styles.MainReID}`}><span>{item?.property_name}</span> <span>{item?.apt_no}</span></p>
                </div>
              </div>
            </div>
          </Link>
        )
      })}
    </div>
  </>);
}

export default ListRecords;